import { Departments } from '@/types';

const storagePrefix = 'ezocrm_storage_';
const analyticsBaseUnlockKey = `${storagePrefix}analytics_base_unlock`;

const storage = {
  getToken: () => {
    const token = window.localStorage.getItem(`${storagePrefix}token`);
    if (token) {
      return JSON.parse(token);
    }
  },
  setToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
    window.sessionStorage.removeItem(analyticsBaseUnlockKey);
  },
  getAnalyticsBaseUnlockToken: () => window.sessionStorage.getItem(analyticsBaseUnlockKey),
  setAnalyticsBaseUnlockToken: (token: string) => {
    window.sessionStorage.setItem(analyticsBaseUnlockKey, token);
  },
  clearAnalyticsBaseUnlockToken: () => {
    window.sessionStorage.removeItem(analyticsBaseUnlockKey);
  },
  getDepartment: () => window.localStorage.getItem(`${storagePrefix}department`),
  setDepartment: (dep: Departments) =>
    window.localStorage.setItem(`${storagePrefix}department`, dep),
  getContentPlatform: () => window.localStorage.getItem(`${storagePrefix}content_platform`),
  setContentPlatform: (platform: string) =>
    window.localStorage.setItem(`${storagePrefix}content_platform`, platform),
  getContentPageIds: (): Record<string, string> => {
    const raw = window.localStorage.getItem(`${storagePrefix}content_page_ids`);
    if (!raw) {
      return {};
    }
    try {
      return JSON.parse(raw) as Record<string, string>;
    } catch {
      return {};
    }
  },
  setContentPageId: (scope: string, pageId: string) => {
    const current = storage.getContentPageIds();
    window.localStorage.setItem(
      `${storagePrefix}content_page_ids`,
      JSON.stringify({ ...current, [scope]: pageId })
    );
  },
};

export default storage;
